import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Importar tus archivos JSON
import esCommon from '../locales/es/common.json';
import esNavigation from '../locales/es/navigation.json';
import enCommon from '../locales/en/common.json';
import enNavigation from '../locales/en/navigation.json';

const resources = {
  es: {
    common: esCommon,
    navigation: esNavigation
  },
  en: {
    common: enCommon,
    navigation: enNavigation
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en', // idioma por defecto
    fallbackLng: 'en',
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
    debug: true, // Activa esto para ver errores en consola
  });

export default i18n;